import { BifrostBackendApi, BifrostBackendNestApi } from "../../gateways/BifrostBackendApi";
import { store } from "../../store";

const PersonServiceProvider = {
	baseUrl: `/person`,
	nestBaseUrl: `/users`,
	nestIntBaseUrl: `intusr/users`,
	async createPerson(tenantId, user ) {
		return BifrostBackendApi.post(`${this.baseUrl}?tenantId=${tenantId}`, user);
	},
	async deletePerson(tenantId, token) {
		return BifrostBackendNestApi.delete(`${this.nestBaseUrl}/remove`, {
			params: { tenantId: tenantId },
			headers: {
				Authorizationidp: token
			}
		});
	},
	async updatePerson(tenantId, token, user) {
		if (store.getters.subscriptionExistsData.useNewSubscriptionEndPoint) {
			return BifrostBackendNestApi.put(`${this.nestBaseUrl}`, user, {
				headers: {
					Authorizationidp: token
				}
			});
		} else {
			return BifrostBackendApi.put(`${this.baseUrl}/${token}`, user, {
				params: { tenantId: tenantId },
				headers: {
					Authorizationidp: token
				}
			});
		}
	},
	async getPersonData(tenantId, token) {
		const personQueryParams = {
			tenantId
		};
		return BifrostBackendNestApi.get(`${this.nestIntBaseUrl}/details`, {
			params: personQueryParams,
			headers: {
				Authorizationidp: token
			}
		});
	},
	async verifyPersonExistsByEmail(tenantId, email ) {
		const personQueryParams = {
			tenantId,
			email: encodeURIComponent(email)
		};
		return BifrostBackendNestApi.get(this.nestIntBaseUrl, {
			params: personQueryParams
		});
	}
};

export default Object.freeze(PersonServiceProvider);
